import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export default function AuthGate({ children }: { children: React.ReactNode }) {
  const { token, loading, checkAuth, skipAuth } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect groundcontrol subdomain to Store Hub
  useEffect(() => {
    if (window.location.hostname === 'groundcontrol.thefifthplanet.com' && !location.pathname.startsWith('/store') && !location.pathname.startsWith('/staff')) {
      navigate('/store', { replace: true });
    }
  }, [location.pathname]);

  // Auth check — runs after any redirects settle
  useEffect(() => {
    // Don't run auth check until redirect is complete
    if (window.location.hostname === 'groundcontrol.thefifthplanet.com' && !location.pathname.startsWith('/store') && !location.pathname.startsWith('/staff')) {
      return;
    }

    const isPublic = location.pathname === '/store/login' || location.pathname.startsWith('/attestation');

    if (isPublic) {
      skipAuth();
    } else {
      checkAuth();
    }
  }, [location.pathname]);

  // Redirect unauthenticated users
  useEffect(() => {
    if (loading) return;
    if (token) return;

    const path = location.pathname;

    // Public paths — no redirect
    if (path === '/store/login' || path.startsWith('/attestation')) return;

    // Store paths → store login
    if (path.startsWith('/store')) {
      navigate('/store/login', { replace: true });
      return;
    }

    // Everything else → admin login
    if (path !== '/login') {
      navigate('/login');
    }
  }, [loading, token, location.pathname]);

  if (loading) {
    return <div className="flex items-center justify-center h-screen text-gray-500">Loading...</div>;
  }

  return <>{children}</>;
}
